module.exports = __webpack_public_path__ + "media/images/wedding/13-7bbb131aa2552ab447d2287cbdb6ad45.jpg";